import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchData(ctx, id) {
            return new Promise((resolve, reject) => {
              axios
                .get('/blogs/v1/block/getall/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        UpdateOrder(ctx, queryParams) {
            var data = JSON.stringify(queryParams.items);    
            return new Promise((resolve, reject) => {
              axios
                .put('/blogs/v1/block/updateOrdering' , data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addBlock(ctx, queryParams) {
            return new Promise((resolve, reject) => {
              axios
                .post('/blogs/v1/block/add',queryParams)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        UpdateBlock(ctx, queryParams) {
            
            return new Promise((resolve, reject) => {
              axios
                .put('/blogs/v1/block/update/'+queryParams.id,queryParams.formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteBlock(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                  .delete('/blogs/v1/block/delete/'+id)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })

        }
    }
}